import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExpandComponent } from './expand.component';


@NgModule({
    declarations: [
        ExpandComponent
    ],
    exports: [
        ExpandComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ExpandModule { }
